import { render } from "./dimensional-square-lingbao.vue?vue&type=template&id=ca7f4514&scoped=true"
import script from "./dimensional-square-lingbao.vue?vue&type=script&lang=js"
export * from "./dimensional-square-lingbao.vue?vue&type=script&lang=js"

import "./dimensional-square-lingbao.vue?vue&type=style&index=0&id=ca7f4514&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca7f4514"]])

export default __exports__